const ORDER_PACKING_STATUS = {
  needsPrePacking: 'NEEDS_PRE_PACKING',
  inProgress: 'IN_PROGRESS',
  packed: 'PACKED',
};

export default ORDER_PACKING_STATUS;
